/** Certified + Approved packages are the only rows a watermarked export will accept. */
export function isWatermarkedExportEligible(row) {
  const authority = row?.authority_status || row?.authority_state;
  if (authority !== 'APPROVED') return false;
  if (row?.package_status && row.package_status !== 'CERTIFIED') return false;
  return true;
}

export function rememberEligibility(current, rows, getId) {
  const next = { ...current };
  (rows || []).forEach((row) => {
    const id = getId(row);
    if (id) next[id] = isWatermarkedExportEligible(row);
  });
  return next;
}

export function eligibleExportIds(selectedIds, eligibilityById) {
  return Array.from(selectedIds || []).filter((id) => eligibilityById?.[id]);
}
